
import { mapGetters, mapState } from "vuex";
import { Component, Vue } from "vue-property-decorator";
import BrochureDetails from "./BrochureDetails.vue";
import Brochure from "@/models/Brochure";

@Component({
  components: {
    BrochureDetails
  },
  computed: {
    ...mapGetters("BrochureAanvraag", ["GetFilteredBrochuresCount"]),
    ...mapState("BrochureAanvraag", ["loading", "selectedBrochures"])
  }

})
export default class SelectedBrochures extends Vue {
  dialog = false;
  selBrochures: Brochure[] = [];

  get count() {
    return this.$store.state.BrochureAanvraag.selectedBrochures.length;
  }

  get brochures() {
    const selBrochures =
      this.$store.state.BrochureAanvraag.selectedBrochures.map((id: string) => {
        return this.$store.state.BrochureAanvraag.brochuresById[id];
      });
    return selBrochures.sort(function (a: Brochure, b: Brochure) {
      const aConcat = a.name;
      const bConcat = b.name;

      if (aConcat > bConcat) {
        return 1;
      } else if (aConcat < bConcat) {
        return -1;
      } else {
        return 0;
      }
    });
  }
}
